export default "__VITE_ASSET__CgJB$aZn__";